(function () {
  if (window.NativeProductSliders) return;

  const initSlider = (slider) => {
    if (slider.dataset.sliderReady === 'true') return;

    const track = slider.querySelector('[data-slider-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    const dots = slider.querySelector('[data-slider-dots]');
    if (!track || !prev || !next || !dots) return;

    slider.dataset.sliderReady = 'true';

    const getItems = () => Array.from(track.children);
    const getItemLeft = (item) => Math.max(0, item.offsetLeft - track.offsetLeft);
    const getStepSize = () => {
      const items = getItems();
      if (items.length < 2) return items[0]?.getBoundingClientRect().width || track.clientWidth || 1;
      return Math.max(1, getItemLeft(items[1]) - getItemLeft(items[0]));
    };
    const getVisibleCount = () => Math.max(1, Math.floor((track.clientWidth + 1) / getStepSize()));
    const getPages = () => Math.max(1, Math.ceil(getItems().length / getVisibleCount()));
    const getCurrentPage = () => {
      const firstVisibleIndex = Math.round(track.scrollLeft / getStepSize());
      return Math.max(0, Math.min(getPages() - 1, Math.round(firstVisibleIndex / getVisibleCount())));
    };
    const getTargetScroll = (page) => {
      const items = getItems();
      if (!items.length) return 0;
      const targetIndex = Math.min(items.length - 1, Math.max(0, page * getVisibleCount()));
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      return Math.min(maxScroll, getItemLeft(items[targetIndex] || items[0]));
    };

    const renderDots = () => {
      const pages = getPages();
      dots.innerHTML = '';
      slider.classList.toggle('native-slider--static', pages <= 1);

      for (let index = 0; index < pages; index += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'native-slider__dot';
        button.setAttribute('aria-label', `Go to slide ${index + 1}`);
        button.addEventListener('click', () => {
          track.scrollTo({ left: getTargetScroll(index), behavior: 'smooth' });
        });
        dots.appendChild(button);
      }
    };

    const update = () => {
      const activeIndex = getCurrentPage();
      dots.querySelectorAll('.native-slider__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    prev.addEventListener('click', () => {
      track.scrollTo({ left: getTargetScroll(getCurrentPage() - 1), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollTo({ left: getTargetScroll(getCurrentPage() + 1), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => {
      renderDots();
      update();
    });

    renderDots();
    update();
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-native-product-slider]')) initSlider(root);
    root.querySelectorAll('[data-native-product-slider]').forEach(initSlider);
  };

  const initAutoplayVideos = (root = document) => {
    const videos = root.querySelectorAll('video.native-product-details__autoplay-video:not([data-autoplay-ready])');
    if (!videos.length) return;

    videos.forEach((video) => {
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.pause();
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.35 }
    );

    videos.forEach((video) => observer.observe(video));
  };

  const initPage = (root = document) => {
    initAll(root);
    initAutoplayVideos(root);
  };

  window.NativeProductSliders = { initAll, initAutoplayVideos };
  document.addEventListener('DOMContentLoaded', () => initPage());

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initPage(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
